/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Include_FsInputs */

const en_dialogue_list_export_include_fs = /** @type {(inputs: Dialogue_List_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include FS`)
};

const fr_dialogue_list_export_include_fs = /** @type {(inputs: Dialogue_List_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclure FS`)
};

const de_dialogue_list_export_include_fs = /** @type {(inputs: Dialogue_List_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FS einschließen`)
};

const it_dialogue_list_export_include_fs = /** @type {(inputs: Dialogue_List_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Includi FS`)
};

const ru_dialogue_list_export_include_fs = /** @type {(inputs: Dialogue_List_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить FS`)
};

const es_dialogue_list_export_include_fs = /** @type {(inputs: Dialogue_List_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir FS`)
};

const zh_cn2_dialogue_list_export_include_fs = /** @type {(inputs: Dialogue_List_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包括 FS`)
};

const ja_dialogue_list_export_include_fs = /** @type {(inputs: Dialogue_List_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FSを含める`)
};

const hi_dialogue_list_export_include_fs = /** @type {(inputs: Dialogue_List_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एफएस शामिल करें`)
};

const pt_pt2_dialogue_list_export_include_fs = /** @type {(inputs: Dialogue_List_Export_Include_FsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir FS`)
};

/**
* | output |
* | --- |
* | "Include FS" |
*
* @param {Dialogue_List_Export_Include_FsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_include_fs = /** @type {((inputs?: Dialogue_List_Export_Include_FsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Include_FsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_include_fs(inputs)
	if (locale === "de") return de_dialogue_list_export_include_fs(inputs)
	if (locale === "it") return it_dialogue_list_export_include_fs(inputs)
	if (locale === "ru") return ru_dialogue_list_export_include_fs(inputs)
	if (locale === "es") return es_dialogue_list_export_include_fs(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_include_fs(inputs)
	if (locale === "ja") return ja_dialogue_list_export_include_fs(inputs)
	if (locale === "hi") return hi_dialogue_list_export_include_fs(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_include_fs(inputs)
	return en_dialogue_list_export_include_fs(inputs)
});